module.exports = __webpack_public_path__ + "img/octopus.c4aa1fbd.svg";